module.exports = __webpack_public_path__ + "img/EmailIcon.f6416e4a.svg";